import React, { useState } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(BACKEND_URL + '/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.detail || 'Something went wrong');
      } else {
        // Do NOT redirect — stay on page and show the success state.
        setSubmitted(true);
      }
    } catch (err) {
      setError('Unable to reach the server. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center relative overflow-hidden bg-gradient-to-tl from-blue-900 to-black">
      {/* Background Layer */}
      <div className="absolute inset-0 z-0" />

      {/* Content Layer — glass card identical to Login.js */}
      <div
        className="w-full max-w-md p-8 m-4 relative z-10"
        style={{
          background: 'rgba(70, 68, 68, 0.14)',
          borderRadius: '16px',
          boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
          backdropFilter: 'blur(5.5px)',
          WebkitBackdropFilter: 'blur(5.5px)',
          border: '1px solid rgba(255, 255, 255, 0.3)'
        }}
      >
        {submitted ? (
          <div>
            <div className="flex justify-center">
              <svg className="w-12 h-12 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h2 className="text-center text-2xl font-bold text-gray-50 mt-4">
              Check your email
            </h2>
            <p className="text-center text-sm text-white mt-2">
              If this email is registered, a reset link has been sent. Please check your inbox and spam folder.
            </p>
            <a href="/" className="block text-center text-sm text-white text-opacity-70 hover:text-opacity-100 mt-4">
              Back to Login
            </a>
          </div>
        ) : (
          <div>
            <h2 className="text-center text-3xl font-bold text-gray-50 drop-shadow-sm">
              Reset Password
            </h2>
            <p className="mt-2 text-center text-sm text-white">
              Enter your email address and we'll send you a reset link.
            </p>

            <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-200 shadow-sm">
                  Email Address
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 transition duration-200 bg-white bg-opacity-90 text-gray-900"
                  autoComplete="username"
                  placeholder="Enter your email"
                />
              </div>

              {error && (
                <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative text-sm" role="alert">
                  <span className="block sm:inline">{error}</span>
                </div>
              )}

              <button
                type="submit"
                disabled={loading}
                className="w-full flex justify-center py-2.5 px-4 border border-transparent rounded-md shadow-lg text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-400 disabled:opacity-50 disabled:cursor-not-allowed transition duration-200 transform bg-blue-600 hover:bg-blue-700"
              >
                {loading ? (
                  <span className="flex items-center">
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Sending...
                  </span>
                ) : (
                  'Send Reset Link'
                )}
              </button>

              <a href="/" className="block text-center text-sm text-white text-opacity-70 hover:text-opacity-100 mt-4">
                Back to Login
              </a>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
